import type {
  GetCarPriceRangeText,
  GetFormattedLaunchDateString,
  PriceRange,
} from './types';

export const getFormattedLaunchDateString: GetFormattedLaunchDateString = (
  launchDateString,
) => {
  const date = new Date(launchDateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const quarter = `Q${Math.ceil(month / 3)}`;

  return `${quarter} ${year}`;
};

export const getPriceRangeText: GetCarPriceRangeText = (
  priceRange: PriceRange,
) => {
  const { lowest, highest } = priceRange;

  if (!lowest && !highest) {
    return 'POA';
  }

  if (lowest && highest && lowest === highest) {
    return `$${lowest.toLocaleString('en-US')}`;
  }
  return `$${lowest?.toLocaleString('en-US')} - $${highest?.toLocaleString('en-US')}`;
};
